import React from "react"
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';

class Editor extends React.Component {

    state ={
        editorHtml: "",
        theme: 'snow'
    }

    handleChange =  (html) => {
        this.setState({ editorHtml: html });
        this.props.sendData(html)
    }

    componentDidMount() {
        this.setState(() => ({
            editorHtml: this.props.upstream
        }))
    }

    render () {
        return (
            <div>
                <ReactQuill
                    theme={"snow"}
                    onChange={this.handleChange}
                    value={this.state.editorHtml || ''}
                    modules={Editor.modules}
                    formats={Editor.formats}
                    className="Editor"
                    placeholder={this.props.placeholder}
                />
            </div>
        )
    }
}

/*
 * Quill modules to attach to editor
 * See https://quilljs.com/docs/modules/ for complete options
 */
Editor.modules = {
    toolbar: [
        [{size: []}],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [{ align: '' }, { align: 'center' }, { align: 'justify' }, {align: 'right'}],
        [{'list': 'ordered'}, {'list': 'bullet'}],
        ['link'],
        ['clean']
    ],
    clipboard: {
        // toggle to add extra line breaks when pasting HTML:
        matchVisual: false,
    }
};
/*
 * Quill editor formats
 * See https://quilljs.com/docs/formats/
 */
Editor.formats = [
    'header', 'font', 'size',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet','align',
    'link'
];

/*
 * PropType validation
 */
export default Editor
